var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSms({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    className: "si-glyph si-glyph-sms",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "838") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 5.000000)",
    fill: "#434343"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.002,6.984 C1.21,6.984 0.496,6.512 0.18,5.785 C0.074,5.537 0.171,5.239 0.401,5.122 C0.63,5.006 0.903,5.112 1.012,5.361 C1.175,5.742 1.563,5.99 2.002,5.99 C2.592,5.99 3.07,5.541 3.07,4.991 C3.07,4.441 2.591,3.994 2.002,3.994 C0.904,3.994 0.018,3.1 0.018,2.004 C0.018,0.908 0.905,0.016 1.995,0.016 C2.782,0.016 3.492,0.484 3.807,1.206 C3.915,1.456 3.818,1.753 3.588,1.87 C3.359,1.988 3.087,1.881 2.979,1.633 C2.814,1.256 2.429,1.01 1.996,1.01 C1.41,1.01 0.935,1.457 0.935,2.004 C0.935,2.551 1.41,2.996 1.996,2.996 C3.099,2.996 3.989,3.892 3.989,4.991 C3.987,6.09 3.097,6.984 2.002,6.984 L2.002,6.984 Z",
    className: "si-glyph-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.997,6.928 C13.216,6.928 12.512,6.465 12.199,5.748 C12.095,5.504 12.191,5.212 12.417,5.097 C12.643,4.985 12.912,5.088 13.02,5.332 C13.182,5.707 13.565,5.949 13.998,5.949 C14.579,5.949 15.052,5.508 15.052,4.969 C15.052,4.428 14.579,3.988 13.998,3.988 C12.914,3.988 12.041,3.111 12.041,2.033 C12.041,0.956 12.914,0.079 13.989,0.079 C14.766,0.079 15.468,0.539 15.776,1.249 C15.883,1.495 15.786,1.786 15.56,1.901 C15.336,2.017 15.066,1.912 14.959,1.668 C14.797,1.298 14.417,1.057 13.988,1.057 C13.412,1.057 12.943,1.496 12.943,2.034 C12.943,2.572 13.412,3.01 13.988,3.01 C15.077,3.01 15.955,3.889 15.955,4.971 C15.955,6.049 15.077,6.928 13.997,6.928 L13.997,6.928 Z",
    className: "si-glyph-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5,6.979 C5.158,6.979 5.018,6.668 5.018,6.286 L5.018,0.739 C5.018,0.437 5.172,0.078 5.444,0.078 C5.985,0.078 8.001,2.643 8.001,2.643 C8.001,2.643 10.001,0.048 10.521,0.048 C10.794,0.048 10.994,0.449 10.994,0.75 L10.994,6.234 C10.994,6.616 10.859,6.956 10.517,6.956 C10.174,6.956 10.017,6.645 10.017,6.264 L10.017,1.891 C10.017,1.891 8.2,3.985 8.001,3.985 C7.809,3.961 5.985,1.86 5.985,1.86 L5.985,6.254 C5.984,6.636 5.843,6.979 5.5,6.979 L5.5,6.979 Z",
    className: "si-glyph-fill"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSms);
export default __webpack_public_path__ + "static/media/sms.394220225f9652e508ebbe81781bf21d.svg";
export { ForwardRef as ReactComponent };